import { render, staticRenderFns } from "./MentionedUsers.vue?vue&type=template&id=e2552338&scoped=true&"
import script from "./MentionedUsers.vue?vue&type=script&lang=js&"
export * from "./MentionedUsers.vue?vue&type=script&lang=js&"
import style0 from "./MentionedUsers.vue?vue&type=style&index=0&id=e2552338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2552338",
  null
  
)

export default component.exports